import React, { useEffect, useRef } from 'react';
import { externalTagsPlaceholderDivId } from './external-tags-dictionary';

const ExternallyPopulatedTag = ({ tagId }: { tagId: string }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const placeholderEl = document.getElementById(tagId);
        if (placeholderEl && containerRef.current) {
            containerRef.current.replaceWith(placeholderEl);
        }

        return () => {
            const placeholderContainer = document.getElementById(externalTagsPlaceholderDivId);
            if (placeholderContainer) {
                const newPlaceholder = document.createElement('div');
                newPlaceholder.id = tagId;
                placeholderContainer.appendChild(newPlaceholder);
            }
        };
    }, []);

    return <div ref={containerRef} />;
};

export default ExternallyPopulatedTag;
